import { render, staticRenderFns } from "./BackofficeMedico.vue?vue&type=template&id=0c66b462&scoped=true"
import script from "./BackofficeMedico.vue?vue&type=script&lang=ts"
export * from "./BackofficeMedico.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeMedico.vue?vue&type=style&index=0&id=0c66b462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c66b462",
  null
  
)

export default component.exports